import { render } from "./SnuesuRound.vue?vue&type=template&id=816f89ea&scoped=true"
import script from "./SnuesuRound.vue?vue&type=script&lang=js"
export * from "./SnuesuRound.vue?vue&type=script&lang=js"

import "./SnuesuRound.vue?vue&type=style&index=0&id=816f89ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816f89ea"]])

export default __exports__